export default "__VITE_ASSET__yU7xzePd__"